import angularModule from 'ProgramSwitcher/angularModule/scripts/program_switcher_module';
import template from 'ProgramSwitcher/angularModule/views/program_switcher.html';
import cacheAngularTemplate from 'cacheAngularTemplate';
import { type CurrentUserIguanaObject } from 'Users';
import { type TranslationHelperClass } from 'Translation';
import { type IScope } from 'angular';
import { type ProgramSwitcherProgramConfig } from '../../ProgramSwitcher.types';

interface Scope extends IScope {
    currentUser: CurrentUserIguanaObject;
    programConfigs: ProgramSwitcherProgramConfig[];
    visibleConfigs: ProgramSwitcherProgramConfig[];
    hiddenConfigs: ProgramSwitcherProgramConfig[];
    switchProgram: (programConfig: ProgramSwitcherProgramConfig) => void;
    isSwitching?: boolean;
    onProgramSwitch?: () => void;
    showMore: boolean;
    toggleShowMore: () => void;
    showMoreLabel: string;
    showLessLabel: string;
}

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive<Scope>('programSwitcher', [
    '$injector',

    function factory($injector) {
        const $rootScope = $injector.get('$rootScope');
        const DialogModal = $injector.get('DialogModal');
        const TranslationHelper = ($injector as angular.auto.IInjectorService).get<TranslationHelperClass>(
            'TranslationHelper',
        );
        const translationHelper = new TranslationHelper('navigation.app_menu_user');

        return {
            restrict: 'E',
            templateUrl,
            scope: {
                programConfigs: '<',
                onProgramSwitch: '<',
            },
            link(scope) {
                Object.defineProperty(scope, 'currentUser', {
                    get() {
                        return $rootScope.currentUser;
                    },
                });

                scope.showMore = false;
                scope.showMoreLabel = translationHelper.get('show_past_applications');
                scope.showLessLabel = translationHelper.get('hide_past_applications');

                scope.$watchCollection('programConfigs', (configs: ProgramSwitcherProgramConfig[]) => {
                    scope.visibleConfigs = (configs || []).filter(c => !c.hiddenByDefault);
                    scope.hiddenConfigs = (configs || []).filter(c => c.hiddenByDefault);
                });

                scope.toggleShowMore = () => {
                    scope.showMore = !scope.showMore;
                };

                scope.switchProgram = (programConfig: ProgramSwitcherProgramConfig) => {
                    if (programConfig.selected) return;

                    scope.isSwitching = true;

                    if (scope.onProgramSwitch) {
                        scope.onProgramSwitch();
                    }

                    scope.currentUser
                        .changePrefProgram(programConfig.userProgramFieldStateId)
                        .then(() => DialogModal.hideAlerts())
                        .finally(() => {
                            scope.isSwitching = false;
                        });
                };
            },
        };
    },
]);
